import { css } from '@emotion/react';

const makeErrorPageStyling = ({ theme, isRtl }) => {
  return {
    gridContainer: css({
      position: 'relative',
      height: '100%',
      backgroundColor: theme.mvf.palette.background.main,
      direction: isRtl ? 'rtl' : 'ltr',
    }),
    icon: css({
      color: 'rgb(255, 151, 26)',
      fontSize: 50,
    }),
    title: css({
      fontWeight: theme.mvf.typography.weight.thick,
      maxWidth: theme.breakpoints.values.sm,
      textAlign: 'center',
      marginTop: theme.mvf.spacing.tiny,
    }),
    message: css({
      maxWidth: theme.breakpoints.values.sm,
      lineHeight: theme.mvf.lineHeight.small,
      marginTop: theme.mvf.spacing.tiny,
      textAlign: 'center',
    }),
  };
};

export default makeErrorPageStyling;
